export const pricePrecisionDigits = (pricePrecision) =>
  pricePrecision === "hundredths_of_cents" ? 4 : 2
